module.exports = __webpack_public_path__ + "static/media/vision-icon-measure.c7949718.png";